import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getApiV1UserFollowList } from '@/api/sdk.gen'

// 用户级关注状态：维护一份「我已关注的用户 ID 集合」，
// 供论坛列表 / 帖子详情等多个页面共享判断与同步。
export const useFollowStore = defineStore('follow-store', () => {
  const followedIds = ref<Set<number>>(new Set())
  const loaded = ref(false)
  const loading = ref(false)

  function isFollowing(userId: string | number): boolean {
    const uid = Number(userId)
    if (!uid) return false
    return followedIds.value.has(uid)
  }

  function setFollowed(userId: string | number, value: boolean) {
    const uid = Number(userId)
    if (!uid) return
    const next = new Set(followedIds.value)
    if (value) next.add(uid)
    else next.delete(uid)
    followedIds.value = next
  }

  async function fetchFollowedList(force = false) {
    if (loading.value) return
    if (loaded.value && !force) return
    loading.value = true
    try {
      // 用户要求忽略分页 → 一次性拉取一个足够大的 size，覆盖所有关注
      const res = await getApiV1UserFollowList({ query: { page: 1, size: 10000 } })
      const list = res.data?.data?.list ?? []
      const next = new Set<number>()
      for (const item of list) {
        const id = item.user_id ?? item.id
        if (id) next.add(id)
      }
      followedIds.value = next
      loaded.value = true
    } catch {
      /* ignore，下次再试 */
    } finally {
      loading.value = false
    }
  }

  function reset() {
    followedIds.value = new Set()
    loaded.value = false
  }

  return {
    followedIds,
    loaded,
    loading,
    isFollowing,
    setFollowed,
    fetchFollowedList,
    reset,
  }
})
